import { defineMessages } from 'react-intl';

import { EPage } from '@types';

export const messages = {
  [EPage.CART]: defineMessages({
    title: {
      id: 'checkout.cartPage.meta.title',
      defaultMessage: 'Shopping Basket',
      description: 'CartPage title tag',
    },
    description: {
      id: 'checkout.cartPage.meta.description',
      defaultMessage: 'Shop perfumes, cologne and beauty products at notino.com ❤',
      description: 'CartPage meta tag with name description',
    },
    keywords: {
      id: 'checkout.cartPage.meta.keywords',
      defaultMessage: 'Notino',
      description: 'CartPage meta tag with name keywords',
    },
  }),
  [EPage.UPSELLING]: defineMessages({
    title: {
      id: 'checkout.upsellingPage.meta.title',
      defaultMessage: 'Pick Discount',
      description: 'UpsellingPage title tag',
    },
    description: {
      id: 'checkout.upsellingPage.meta.description',
      defaultMessage: 'Shop perfumes, cologne and beauty products at notino.com ❤',
      description: 'UpsellingPage meta tag with name description',
    },
    keywords: {
      id: 'checkout.upsellingPage.meta.keywords',
      defaultMessage: 'Notino',
      description: 'UpsellingPage meta tag with name keywords',
    },
  }),
  [EPage.THANK_YOU]: defineMessages({
    title: {
      id: 'checkout.thankYouPage.meta.title',
      defaultMessage: 'Thank you for your purchase',
      description: 'ThankYouPage title tag',
    },
    description: {
      id: 'checkout.thankYouPage.meta.description',
      defaultMessage: 'Shop perfumes, cologne and beauty products at notino.com ❤',
      description: 'ThankYouPage meta tag with name description',
    },
    keywords: {
      id: 'checkout.thankYouPage.meta.keywords',
      defaultMessage: 'Notino',
      description: 'ThankYouPage meta tag with name keywords',
    },
  }),
  [EPage.DELIVERY_AND_PAYMENT]: defineMessages({
    title: {
      id: 'checkout.deliveryAndPaymentPage.meta.title',
      defaultMessage: 'Payment',
      description: 'DeliveryAndPaymentPage title tag',
    },
    description: {
      id: 'checkout.deliveryAndPaymentPage.meta.description',
      defaultMessage: 'Shop perfumes, cologne and beauty products at notino.com ❤',
      description: 'DeliveryAndPaymentPage meta tag with name description',
    },
    keywords: {
      id: 'checkout.deliveryAndPaymentPage.meta.keywords',
      defaultMessage: 'Notino',
      description: 'DeliveryAndPaymentPage meta tag with name keywords',
    },
  }),
  [EPage.SUMMARY]: defineMessages({
    title: {
      id: 'checkout.summaryPage.meta.title',
      defaultMessage: 'Delivery address',
      description: 'Summary title tag',
    },
    description: {
      id: 'checkout.summaryPage.meta.description',
      defaultMessage: 'Shop perfumes, cologne and beauty products at notino.com ❤',
      description: 'Summary meta tag with name description',
    },
    keywords: {
      id: 'checkout.summaryPage.meta.keywords',
      defaultMessage: 'Notino',
      description: 'Summary meta tag with name keywords',
    },
  }),
  [EPage.HOME_PAGE]: undefined,
  [EPage.RESERVATION]: undefined,
  [EPage.CART_LOG_IN]: undefined,
  [EPage.PAYMENT_AND_DELIVERY]: undefined,
  [EPage.RESERVATION_PAYMENT_AND_DELIVERY]: undefined,
  [EPage.LOGIN_PAGE]: undefined,
  [EPage.BENEFITS_PAGE]: undefined,
  [EPage.DISCOVERY_BOX]: undefined,
  [EPage.REGISTER_PAGE]: undefined,
  [EPage.ADYEN_PAYMENT_REDIRECT_PAGE]: undefined,
  [EPage.GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE]: undefined,
  [EPage.REPAY]: undefined,
  [EPage.GOPAY_PAYMENT_REDIRECT_PAGE]: undefined,
  [EPage.LOYALTY_PROGRAM]: undefined,
  [EPage.PRZELEWY_PAYMENT_REDIRECT_PAGE]: undefined,
};
